import { Space, ObjectType } from '@fullstory/proto/fs/services/dx-objects';
import { Tooltip, Text } from '@fullstory/components';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { ActiveSpaceContext } from '../../contexts';
import { Avatar } from '../Avatar';
import { PSEUDO_SPACES } from '../../constants';

export const SpaceLinkIndicator: React.FC<{ objectType: ObjectType; space?: Space | null }> = ({
  objectType,
  space,
}) => {
  const { activeSpace } = useContext(ActiveSpaceContext);
  const isActivePseudoSpace = PSEUDO_SPACES.includes(activeSpace?.space?.id ?? '');

  return (
    <>
      {activeSpace?.space && space && activeSpace.space.id !== space.id && !isActivePseudoSpace && (
        <Tooltip
          tooltipContent={
            <Text appearance="bodySmall" color="default-inverse">
              <FormattedMessage
                defaultMessage="This {objectType, select, 1 {metric} 2 {funnel} 3 {retention} 5 {segment} 6 {dashboard} 7 {heatmap} 8 {journey} other {object}} was added from <b>{name}</b>."
                id="EfZ1z1"
                values={{
                  name: space.name,
                  b: s => <b>{s}</b>,
                  objectType,
                }}
              />
            </Text>
          }
        >
          <Avatar color={space.color} size="small" />
        </Tooltip>
      )}
    </>
  );
};
